<template>
  <div class="moreList">
   <span @click="handleDirect(url)">{{name}}</span>
  </div>

</template>

<script>
    export default {
        name: "moreList",
        props:{
            name:{
                type:String,
                default:"更多"
            },
            url:{
                type:String,
                default:""
            }

        },
        methods:{
            handleDirect(url){
                this.$router.push(
                    {path: url}
                )
            }

        }
    }
</script>

<style scoped>
.moreList{
  height: 50px;
  line-height: 50px;

  width: 100%;

  color: #6a6a6a;

}
  .moreList>span{
    border-bottom: 1px solid #6a6a6a;
    cursor: pointer;
  }

@media (min-width: 1400px) {

  .moreList>span{
    font-size: 20px;
  }

}
/**在768和1199像素之间的屏幕里，中等屏幕，分辨率低的PC**/
@media (min-width: 992px) and (max-width:1399px) {
  .moreList>span{
    font-size: 16px;
  }




}


/**在768和991像素之间的屏幕里，小屏幕，主要是PAD**/
@media (min-width:768px ) and (max-width:991px) {
  .moreList>span{
    font-size: 16px;
  }

}


@media (max-width:767px) {
  .moreList>span{
    font-size: 10px;
  }


}




</style>



// WEBPACK FOOTER //
// src/components/moreList/moreList.vue